import { useEffect, useState } from 'react'
import { Popover, Input, Button, Tag, message, InputNumber } from 'antd'
import Style from './customMutilSelect.module.scss'
import { attributeTypeEnum } from '@/global/enum/product'
import {
  SpecAttributeForScpVo,
  SpecAttributeValueForScpVO,
} from '@/api/reportApi'

interface TagItem {
  id: string
  label: string
}

interface Props {
  onChange: (value: TagItem[]) => void
  defaultValue: TagItem[]
  placeholder?: string
  onAddTag?: (tagName: string) => Promise<{ id: string; label: string }>
  attributeType: string
  record?: SpecAttributeForScpVo
}

const CustomMultiSelect = (props: Props) => {
  const {
    onChange,
    defaultValue,
    placeholder = '请输入属性值',
    onAddTag,
    record,
  } = props
  const [inputValue, setInputValue] = useState<string>('')
  const [selectedTags, setSelectedTags] = useState<TagItem[]>(
    defaultValue || [],
  )
  const [errorText, setErrorText] = useState<string>('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const { specAttributeValueForScpVOList = [] } = record || {}
    const data: TagItem[] = []
    specAttributeValueForScpVOList.forEach(
      (item: SpecAttributeValueForScpVO) => {
        if (item.selected) {
          data.push({
            id: item.specAttributeValueCode,
            label: item.specAttributeValueName,
          })
        }
      },
    )
    setSelectedTags(data)
    onChange(data)
  }, [defaultValue, record])

  const handleInputChange = (e: any) => {
    const data = attributeTypeEnum.isLabelsMatchValue(
      ['数值'],
      props.attributeType,
    )
      ? e
      : e.target.value
    setInputValue(String(data))
    if (String(data).trim().length > 100) {
      setErrorText('请输入1-100个字符')
    } else if (selectedTags.some((tag) => tag.label === String(data))) {
      setErrorText('不可重复')
    } else {
      setErrorText('')
    }
  }

  const handleAddTag = async () => {
    if (inputValue.trim() !== '' && !errorText) {
      setLoading(true)
      try {
        let newTag: TagItem

        if (onAddTag) {
          // 调用后端接口
          newTag = await onAddTag(inputValue.trim())
        } else {
          // 模拟接口返回
          newTag = {
            id: Date.now().toString(),
            label: inputValue.trim(),
          }
        }

        const data = [...selectedTags, newTag]
        setSelectedTags(data)
        onChange(data)
        setInputValue('')
        message.success('添加成功')
      } catch (error) {
        message.error('添加失败，请重试')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleDeleteTag = (tagId: string) => {
    const data = selectedTags.filter((item) => item.id !== tagId)
    setSelectedTags(data)
    onChange(data)
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAddTag()
    }
  }

  const content = (
    <div style={{ minWidth: '250px' }}>
      {attributeTypeEnum.isLabelsMatchValue(['数值'], props.attributeType) ? (
        <InputNumber
          value={inputValue}
          placeholder={placeholder}
          style={{ width: '200px', borderColor: errorText ? 'red' : '' }}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />
      ) : (
        <Input
          value={inputValue}
          placeholder={placeholder}
          style={{ width: '200px', borderColor: errorText ? 'red' : '' }}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />
      )}
      <Button
        style={{ marginLeft: '8px' }}
        onClick={handleAddTag}
        loading={loading}
        disabled={!inputValue.trim() || !!errorText}
      >
        新增
      </Button>
      {errorText ? (
        <p style={{ color: 'red', fontSize: '12px', margin: '4px 0 0 0' }}>
          {errorText}
        </p>
      ) : null}
    </div>
  )

  return (
    <Popover
      content={selectedTags.length < 1 ? content : null}
      trigger="click"
      placement="bottomRight"
    >
      <div className={Style[selectedTags.length >= 1 ? '' : 'tag-box']}>
        {selectedTags.map((tag) => (
          <Tag
            closable
            onClose={() => handleDeleteTag(tag.id)}
            key={tag.id}
            className={Style['tag']}
          >
            <span className={Style['tag-span']}>
              <span className={Style['tag-name']}>{tag.label}</span>
            </span>
          </Tag>
        ))}
      </div>
    </Popover>
  )
}

export default CustomMultiSelect
import { useEffect, useState } from 'react'
import { Popover, Input, Button, Tag, message, InputNumber } from 'antd'
import Style from './customMutilSelect.module.scss'
import { attributeTypeEnum } from '@/global/enum/product'
import {
  SpecAttributeForScpVo,
  SpecAttributeValueForScpVO,
} from '@/api/reportApi'

interface TagItem {
  id: string
  label: string
}

interface Props {
  onChange: (value: TagItem[]) => void
  defaultValue: TagItem[]
  placeholder?: string
  onAddTag?: (tagName: string) => Promise<{ id: string; label: string }>
  attributeType: string
  record?: SpecAttributeForScpVo
}

const CustomMultiSelect = (props: Props) => {
  const {
    onChange,
    defaultValue,
    placeholder = '请输入属性值',
    onAddTag,
    record,
  } = props
  const [inputValue, setInputValue] = useState<string>('')
  const [selectedTags, setSelectedTags] = useState<TagItem[]>(
    defaultValue || [],
  )
  const [errorText, setErrorText] = useState<string>('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const { specAttributeValueForScpVOList = [] } = record || {}
    const data: TagItem[] = []
    specAttributeValueForScpVOList.forEach(
      (item: SpecAttributeValueForScpVO) => {
        if (item.selected) {
          data.push({
            id: item.specAttributeValueCode,
            label: item.specAttributeValueName,
          })
        }
      },
    )
    setSelectedTags(data)
    onChange(data)
  }, [defaultValue, record])

  const handleInputChange = (e: any) => {
    const data = attributeTypeEnum.isLabelsMatchValue(
      ['数值'],
      props.attributeType,
    )
      ? e
      : e.target.value
    setInputValue(String(data))
    if (String(data).trim().length > 100) {
      setErrorText('请输入1-100个字符')
    } else if (selectedTags.some((tag) => tag.label === String(data))) {
      setErrorText('不可重复')
    } else {
      setErrorText('')
    }
  }

  const handleAddTag = async () => {
    if (inputValue.trim() !== '' && !errorText) {
      setLoading(true)
      try {
        let newTag: TagItem

        if (onAddTag) {
          // 调用后端接口
          newTag = await onAddTag(inputValue.trim())
        } else {
          // 模拟接口返回
          newTag = {
            id: Date.now().toString(),
            label: inputValue.trim(),
          }
        }

        const data = [...selectedTags, newTag]
        setSelectedTags(data)
        onChange(data)
        setInputValue('')
        message.success('添加成功')
      } catch (error) {
        message.error('添加失败，请重试')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleDeleteTag = (tagId: string) => {
    const data = selectedTags.filter((item) => item.id !== tagId)
    setSelectedTags(data)
    onChange(data)
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAddTag()
    }
  }

  const content = (
    <div style={{ minWidth: '250px' }}>
      {attributeTypeEnum.isLabelsMatchValue(['数值'], props.attributeType) ? (
        <InputNumber
          value={inputValue}
          placeholder={placeholder}
          style={{ width: '200px', borderColor: errorText ? 'red' : '' }}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />
      ) : (
        <Input
          value={inputValue}
          placeholder={placeholder}
          style={{ width: '200px', borderColor: errorText ? 'red' : '' }}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />
      )}
      <Button
        style={{ marginLeft: '8px' }}
        onClick={handleAddTag}
        loading={loading}
        disabled={!inputValue.trim() || !!errorText}
      >
        新增
      </Button>
      {errorText ? (
        <p style={{ color: 'red', fontSize: '12px', margin: '4px 0 0 0' }}>
          {errorText}
        </p>
      ) : null}
    </div>
  )

  return (
    <Popover
      content={selectedTags.length < 1 ? content : null}
      trigger="click"
      placement="bottomRight"
    >
      <div className={Style[selectedTags.length >= 1 ? '' : 'tag-box']}>
        {selectedTags.map((tag) => (
          <Tag
            closable
            onClose={() => handleDeleteTag(tag.id)}
            key={tag.id}
            className={Style['tag']}
          >
            <span className={Style['tag-span']}>
              <span className={Style['tag-name']}>{tag.label}</span>
            </span>
          </Tag>
        ))}
      </div>
    </Popover>
  )
}

export default CustomMultiSelect
